import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class GenererPdfService {
  constructor(private httpClient: HttpClient) {}

  genererPdf(uuid) {
    return this.httpClient
      .get(environment.apiUrl + "souscriptions/" + uuid)
      .pipe((response) => response);
  }
}
